import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, BookOpen } from "lucide-react";
import api from "../api";
import { MonkeyMark } from "./Logo";
import { SocialLinks } from "./SocialLinks";

export const Footer = () => {
  const [books, setBooks] = useState([]);
  useEffect(() => {
    api.get("/books").then((r) => setBooks(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="mt-24 bg-[#12131A] text-cream rounded-t-[2.5rem] border-t-2 border-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <MonkeyMark size={56} />
              <span className="font-display font-black text-4xl sm:text-5xl tracking-tight">
                KITOE
              </span>
            </div>
            <p className="mt-3 text-cream/60 max-w-sm text-sm leading-relaxed">
              Playful quiz and learning games — and friendly colouring books — that
              spark curiosity in players of all ages. Made with love by KITOE
              entertainment.
            </p>
            <div className="mt-6">
              <SocialLinks dark />
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-8 sm:gap-14">
            <div className="flex flex-col gap-2.5 text-sm">
              <span className="text-xs font-extrabold uppercase tracking-[0.2em] text-cream/40 mb-1">
                Explore
              </span>
              <Link data-testid="footer-home-link" to="/" className="hover:text-sun transition-colors">Home</Link>
              <Link data-testid="footer-apps-link" to="/apps" className="hover:text-sun transition-colors">All Games</Link>
              <Link data-testid="footer-books-link" to="/#books" className="hover:text-sun transition-colors">All Books</Link>
              <Link data-testid="footer-about-link" to="/about" className="hover:text-sun transition-colors">About</Link>
              <Link data-testid="footer-contact-link" to="/contact" className="hover:text-sun transition-colors">Contact</Link>
            </div>
            {books.length > 0 && (
              <div className="flex flex-col gap-2.5 text-sm" data-testid="footer-books-section">
                <span className="text-xs font-extrabold uppercase tracking-[0.2em] text-cream/40 mb-1 inline-flex items-center gap-1.5">
                  <BookOpen size={12} /> Colouring books
                </span>
                {books.map((b) =>
                  b.status === "live" && b.amazon_url ? (
                    <a
                      key={b.id}
                      data-testid={`footer-book-link-${b.id}`}
                      href={b.amazon_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-sun transition-colors"
                    >
                      {b.title}
                    </a>
                  ) : (
                    <span key={b.id} data-testid={`footer-book-link-${b.id}`} className="text-cream/50">
                      {b.title} <span className="text-xs">(soon)</span>
                    </span>
                  )
                )}
              </div>
            )}
            <div className="flex flex-col gap-2.5 text-sm">
              <span className="text-xs font-extrabold uppercase tracking-[0.2em] text-cream/40 mb-1">
                Say hello
              </span>
              <a
                data-testid="footer-email-link"
                href="mailto:kitoe.entertainment@gmail.com"
                className="inline-flex items-center gap-2 hover:text-sun transition-colors"
              >
                <Mail size={14} /> kitoe.entertainment@gmail.com
              </a>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-cream/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/40">
          <span>© {new Date().getFullYear()} KITOE entertainment. All rights reserved.</span>
          <span>100% ad-free. Kid-safe. Parent-approved.</span>
        </div>
      </div>
    </footer>
  );
};
